import { render, staticRenderFns } from "./GoToButtonComponent.vue?vue&type=template&id=07d6c6e8&scoped=true&"
import script from "./GoToButtonComponent.vue?vue&type=script&lang=js&"
export * from "./GoToButtonComponent.vue?vue&type=script&lang=js&"
import style0 from "./GoToButtonComponent.vue?vue&type=style&index=0&id=07d6c6e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d6c6e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
